"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceIsActive = exports.DEVICE_ACTIVITY_WINDOW_MONTHS = exports.deviceDeserialize = void 0;
const moment_1 = __importDefault(require("moment"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const DeviceType_1 = require("./DeviceType");
const DatabaseTimestamp_1 = require("./firebase/DatabaseTimestamp");
const UserType_1 = require("./UserType");
function deviceDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value, 'device');
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        creationTimestampMs: (0, unwrap_1.default)(object.creationTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        deviceUniqueId: (0, unwrap_1.default)(object.deviceUniqueId, deserializeString_1.deserializeString),
        fcmRegistrationToken: (0, unwrap_1.default)(object.fcmRegistrationToken, deserializeString_1.deserializeString),
        isSignedIn: (0, unwrap_1.default)(object.isSignedIn, deserializeBoolean_1.default),
        lastUsedTimestampMs: (0, unwrap_1.default)(object.lastUsedTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        make: (0, unwrap_1.default)(object.make, deserializeString_1.deserializeString),
        model: (0, unwrap_1.default)(object.model, deserializeString_1.deserializeString),
        type: (0, DeviceType_1.deviceTypeDeserialize)(object.type),
        uid: (0, deserializeString_1.deserializeString)(object.uid),
        userType: (0, unwrap_1.default)(object.userType, UserType_1.userTypeDeserialize),
    };
}
exports.deviceDeserialize = deviceDeserialize;
exports.DEVICE_ACTIVITY_WINDOW_MONTHS = 1;
function deviceIsActive(device) {
    var _a;
    return (device.isSignedIn === true &&
        ((_a = device.lastUsedTimestampMs) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) >
            (0, moment_1.default)().subtract(exports.DEVICE_ACTIVITY_WINDOW_MONTHS, 'months').valueOf());
}
exports.deviceIsActive = deviceIsActive;
